import React from 'react';

const ErrorDisplay = ({ error, onClose }) => {
  // Extract useful debugging information
  const details = {
    type: error?.response?.data?.error || 'Unknown Error',
    message: error?.response?.data?.details || error?.message || 'An unknown error occurred',
    path: error?.config?.url || window.location.pathname,
    timestamp: new Date().toISOString(),
    // Include debug information from the error response
    ...error?.response?.data?.debug,
    // Additional cookie and header checks
    hasCookie: !!document.cookie.includes('csrf-token'),
    hasHeader: !!(error?.config?.headers && (error?.config?.headers['x-csrf-token'] || error?.config?.headers['X-CSRF-Token']))
  };

  const copyDetails = () => {
    const text = Object.entries(details)
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n');
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-lg w-full mx-4">
        <div className="flex justify-between items-start mb-4">
          <h2 className="text-xl font-semibold text-red-600">Security Error</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>
        
        <div className="mb-4">
          <p className="text-gray-700 mb-2">
            A security verification error has occurred. This can happen if:
          </p>
          <ul className="list-disc ml-6 text-gray-600 text-sm">
            <li>The page was open for a long time without activity</li>
            <li>Multiple tabs are open with different sessions</li>
            <li>Browser cookies were cleared while using the site</li>
          </ul>
        </div>

        <div className="bg-gray-50 p-3 rounded-md mb-4">
          <div className="flex justify-between items-center mb-2">
            <h3 className="text-sm font-medium text-gray-700">Debug Information</h3>
            <button
              onClick={copyDetails}
              className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded hover:bg-blue-100"
            >
              Copy
            </button>
          </div>
          <div className="text-xs font-mono text-gray-600 break-all">
            {Object.entries(details).map(([key, value]) => (
              <div key={key} className="mb-1">
                <span className="font-semibold">{key}:</span> {value.toString()}
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Reload Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay;
